'use client';

import { useEffect } from 'react';
import { initScrollTracking, initTimeTracking } from '@/lib/analytics';

interface KnowledgeBaseEngagementTrackerProps {
  slug: string;
}

/**
 * Client-side engagement tracking for knowledge base articles
 * Tracks scroll depth and time on page for GA4 analytics
 */
export default function KnowledgeBaseEngagementTracker({ slug }: KnowledgeBaseEngagementTrackerProps) {
  useEffect(() => {
    // Initialize scroll depth tracking
    const cleanupScroll = initScrollTracking();

    // Initialize time tracking for knowledge base content
    const cleanupTime = initTimeTracking('knowledge_base', slug);

    // Cleanup on unmount
    return () => {
      cleanupScroll();
      cleanupTime();
    };
  }, [slug]);

  // This component doesn't render anything
  return null;
}
